import { useState } from 'react'
import { ListBalanceHistories } from '~/features/BalanceHistories/ListBalanceHistories'
import { BalanceCalendarHeading } from '~/entities/BalanceHistories'
import { formatDateForApi } from '~/shared/lib/date'
import { PageContainer } from '~/shared/ui/PageContainer'
import { useRefreshPage } from './useRefreshPage'

export function ListBalanceHistoriesPage() {
  const { refreshPage } = useRefreshPage()
  const [date, setDate] = useState<string>(formatDateForApi(new Date()))
  const handleDateChange = (date: string) => setDate(date)

  return (
    <PageContainer
      canBack
      title='История баланса за день'
      topContent={<BalanceCalendarHeading onDateChange={handleDateChange} />}
      onRefreshPage={refreshPage}
    >
      <ListBalanceHistories date={date} />
    </PageContainer>
  )
}
